import React from 'react';
import dayjs from 'dayjs';
import {useCompleteInspectionContext} from '../CompleteInspectionContext';
import {formattingDate} from '../../utils/formattingHelper';
import styles from './styles.module.scss';

export const DocPropsDateShuma = () => {
  const context = useCompleteInspectionContext();
  const {pdfCreateTime, firmShumaID} = context.data.pdfData;
  const pdfCreateTimeValue = formattingDate(pdfCreateTime);
  const value = [
    dayjs().year().toString().slice(-2),
    firmShumaID
  ].join('/');

  return (context.shumaTypeID === 3) || (context.shumaTypeID === 4)
    ? (
      <div className={styles.logoDocProps}>
        <div>
          <div className={styles.docPropsItem}>
            תאריך: {pdfCreateTimeValue}
          </div>
          <div className={styles.docPropsItem}>
            מס' חוות הדעת: {value}
          </div>
        </div>
      </div>
    )
    : null;
};

export default DocPropsDateShuma;
